import styled from 'styled-components';
import { media } from '@packages/ui';
import { SpaceProps, space } from 'styled-system';

// TODO Because of some weird styled-components production issue with missing styles,
// Holder (child) styles are moved to OverflowHide. Clean this up if we remove styled components.
export const OverflowHideBase = styled.div<SpaceProps>`
  width: 100%;
  overflow-x: visible;
  position: relative;
  ${space}
  /* on mobile, it should take all window space and consume container border */
  ${media.to.md`
    width: 100vw;
  `}
  & > div {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    user-select: none;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const OverflowHide = styled(OverflowHideBase)`
  ${media.to.md`
    margin-left: -22px;
  `}
`;

export const ChildrenContainer = styled.div`
  width: 100%;
  display: flex;
  ${media.from.md`
  padding-left: 10px;
`}
`;

// TODO: fix zindex
export const ShadowBoxBigRightShadow = styled.div`
  ${media.from.md`
    box-shadow: 
        inset -75px 0px 25px -10px 
        rgba(255, 255, 255, 0.97), inset 75px 0px 25px -10px 
        rgba(255, 255, 255, 0.97);
    `}
  pointer-events: none;
  z-index: 100;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
`;
